(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD
    define(['torso/modules/NestedModel'], factory);
  } else if (typeof exports === 'object') {
    // Node, CommonJS-like
    module.exports = factory(require('backbone-torso/modules/NestedModel'));
  } else {
    throw 'Only AMD and CommonJS imports are supported.';
  }
}(this, function (TorsoNestedModel) {
  'use strict';

  /**
   * Model representing a css variable
   * Set idAttribute to 'name' since CssVariable is identified by its unique name
   * @class CssVariableModel
   * @constructor
   * @extends Torso.NestedModel
   */
  return TorsoNestedModel.extend({
    idAttribute: 'name'
  });
}));
